export default function AlgoliaGridHit({ hit }) {
  return (
    <article className="group h-full flex flex-col">
      {hit?.images?.grid_image && hit?.post_title && hit?.permalink ? (
        <a href={hit?.permalink}>
          <div className="overflow-hidden">
            <img
              src={hit.images.grid_image}
              className="object-cover object-center aspect-video w-full lg:max-h-[315px] wp-post-image group-hover:scale-105 transition-all duration-250"
              alt={hit.post_title}
              decoding="async"
              loading="lazy"
            />
          </div>
        </a>
      ) : null}
      <div className="text--theme theme--text-card mce-content-body">
        {hit?.post_title && hit?.permalink ? (
          <h3 className="max-xl:text-2xl max-md:text-h3">
            <a
              href={hit?.permalink}
              className="hover:text-gold duration-200 leading-none group-hover:text-gold !no-underline">
              {hit.post_title}
            </a>
          </h3>
        ) : null}

        {hit?.post_date_formatted ? (
          <p className="p--lg">{hit?.post_date_formatted}</p>
        ) : null}
      </div>
    </article>
  )
}
